// @ts-ignore
import Vue from 'vue'
import type { MenuItem } from '@/components/menu-editor/schemas/MenuItem'

export default Vue.extend({
  methods: {
    isParent(el: MenuItem): boolean {
      return !!el?.children?.length
    },
  },
})
